import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'app-error-page',
    templateUrl: './error-page.component.html',
    styleUrls: ['./error-page.component.scss'],
    standalone: true
})
export class ErrorPageComponent implements OnInit {
  public error: { code: number };

  constructor(private route: ActivatedRoute) {
  }

  public ngOnInit(): void {
    this.route.paramMap.subscribe(parameters => {
      this.error = {code: +parameters.get('code')};
    });
  }

  public errorTitle(): string {
    switch (this.error.code) {
      case 401:
        return 'Geen toegang';
      case 403:
        return 'Verboden toegang';
      case 404:
        return 'Niet gevonden';
      case 500:
        return 'Serverfout';
      default:
        return 'Onbekende fout';
    }
  }

  public errorMessage(): string {
    switch (this.error.code) {
      case 401:
        return 'Helaas heb je op dit moment geen toestemming om deze gegevens te bekijken. Waarschijnlijk moet je eerst inloggen, ' +
          'of toestemming krijgen van de eigenaar.';
      case 403:
        return 'Voor dit gedeelte van de applicatie heb je geen toegang. Navigeer verder via het menu.';
      case 404:
        return 'We konden niet vinden wat je zocht. Probeer het nog eens of navigeer verder via het menu.';
      case 500:
        return 'Er heeft zich een fout voorgedaan in de toepassing. We gaan het zo snel mogelijk oplossen.';
      default:
        return 'Er deed zich een onbekende fout voor. We gaan het zo snel mogelijk oplossen.';
    }
  }
}
